"use client";

import React from "react";
import { Clock, Mail, Map, MapPin } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
const locations = [{
  id: 1,
  city: "Адвокатский кабинет",
  top: "45%",
  left: "48%",
  address: "ул. Кирова, д. 2, Калуга, Россия",
  hours: "Пн-Пт: 09:00 - 18:00",
  email: "n.kondrashov@advokat.ru"
}, {
  id: 2,
  city: "Арбитражный суд",
  top: "35%",
  left: "40%",
  address: "ул. Баженова, д. 2, Калуга",
  hours: "По графику заседаний",
  email: "arbitr@kondrashov.pro"
}, {
  id: 3,
  city: "Областной суд",
  top: "55%",
  left: "55%",
  address: "ул. Кутузова, д. 4, Калуга",
  hours: "Представительство",
  email: "court@kondrashov.pro"
}, {
  id: 4,
  city: "Дистанционный хаб",
  top: "25%",
  left: "60%",
  address: "Консультации онлайн",
  hours: "Ежедневно: 10:00 - 20:00",
  email: "info@kondrashov.pro"
}];
export default function WhereWeAreLocated() {
  return <section data-section-id="140141" id="адвокатский-кабинет-в-калуге" className="w-full py-20 md:py-32 bg-background text-primary overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-6 text-primary">Адвокат Николай Кондрашов<br />Профессиональная защита в Калуге, рег. № 40/806</h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl font-sans">Адвокат Николай Кондрашов обеспечивает квалифицированную юридическую защиту в Калуге. Обладая более чем 11-летним опытом и высшим юридическим и психологическим образованием, он специализируется на гражданских спорах и арбитраже, гарантируя надежное и авторитетное представительство ваших интересов.</p>
        </div>

        <div className="relative w-full max-w-6xl mx-auto h-[500px] md:h-[700px] rounded-lg overflow-hidden shadow-xl border border-border/20">
          <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac1c4c09d48cc33f479076da2859f80a17c782d6d5ce717643f72b14b82d9a88c&source=constructor" width="100%" height="100%" className="w-full h-full border-0" title="Карта расположения" />
        </div>
      </div>
    </section>;
}